import { http } from "./client";

const toRecentClientRequest = (client) => {
    const applicationId = client?.applicationid ? Number(client.applicationid) : null;
    const medicaidId = client?.medicaidid || "";

    return {
        applicationId,
        medicaidId
    };
};

export const recordRecentClientRequest = (client) => {
    const payload = toRecentClientRequest(client);

    if (!payload.applicationId && !payload.medicaidId) {
        return Promise.resolve({ recorded: false });
    }

    return http.post("Home/recent-clients", payload)
        .then(() => ({ recorded: true }));
};
